<mat-button-toggle-group (change)="segmentChanged($event)" [value]="items[default]">
  <mat-button-toggle *ngFor="let item of items; trackBy: trackByItems" [value]="item">{{ item }}</mat-button-toggle>
</mat-button-toggle-group>
